import { PanelItem } from '@rta/rta-blueprint-library';

import { SkuColorPreset } from './sku-color-preset.enum';

/**
 * Maps skuColorPreset string names to their hex color values
 */
const PRESET_MAP: Record<string, string> = {
	Green: SkuColorPreset.Green,
	Pink: SkuColorPreset.Pink,
	Purple: SkuColorPreset.Purple,
	Blue: SkuColorPreset.Blue,
	Orange: SkuColorPreset.Orange,
	Red: SkuColorPreset.Red,
	Yellow: SkuColorPreset.Yellow,
	LightYellow: SkuColorPreset.LightYellow,
	White: SkuColorPreset.White,
	Gray: SkuColorPreset.Gray
};

/**
 * Determines the background color for a SKU label
 * Uses the pre-computed skuColorPreset from component data, with runtime override for
 * utility cutout items (green instead of preset)
 */
export const getLabelColor = (
	panelItem: PanelItem,
	customColor?: string,
	_isOnUtilityPanel?: boolean
): string => {
	if (customColor) {
		return customColor;
	}

	const { item } = panelItem;
	const { skuColorPreset } = item;

	if (item.category?.isUtilityCutout) {
		return SkuColorPreset.Green;
	}

	return PRESET_MAP[skuColorPreset] ?? SkuColorPreset.White;
};
